export default {"src":"/_next/static/media/abu-dhabi.de56196e.svg","height":104,"width":184,"blurWidth":0,"blurHeight":0};